$(document).ready ->

  croppie = ''

  if $("#organization_errors").length > 0
    alert($("#organization_errors").val())

  if $(".organizations").length > 0
    $("ul[class='pagination']").children("li").css("display","inline-block")
    $("div[class='pagination']").css "display", "inline-block"
    $("div[class='pagination_status']").css "display", "inline-block"

  $("#select_year").change (e) ->
    if $('#include_free_accounts').prop('checked')
      include_free_accounts = "true"
    else
      include_free_accounts = "false"
    window.location = "#{$(e.target).parents('form').attr('action')}?include_free_accounts=#{include_free_accounts}#{if !!$(e.target).val() then "&year="+$(e.target).val() else ''}"

  $('#include_free_accounts').click (e) ->
    if $('#include_free_accounts').prop('checked')
      include_free_accounts = "true"
    else
      include_free_accounts = "false"
    window.location = "#{$(e.target).parents('form').attr('action')}?include_free_accounts=#{include_free_accounts}#{if !!$("#select_year").val() then "&year="+$("#select_year").val() else ''}"

  $("#startExportMetaData").click ->
    $.get("/applications/start_export_meta_data").done(
      (success) ->
        $("#exportMetaDataModalContainer").empty()
        $("#exportMetaDataModalContainer").append(success)
        $("#exportMetaDataModalContainer > .modal").openModal()
        $('select.chosen-select').chosen({
          allow_single_deselect: true,
          no_results_text: 'No results matched',
          width: '200px'
        })
    ).fail(
      (error) ->
        console.log error
    )

  $("a[data-reveal-id^='editModal-']").click ->
    application_id = $(this).attr('data-reveal-id').split('-')[1]
    $.get("/applications/#{application_id}/edit_modal").done(
      (success) ->
        $("#editApplicationModalContainer").empty()
        $("#editApplicationModalContainer").append(success)
        $("#editApplicationModalContainer > .modal").openModal()
        $("#editApplicationModalContainer").trigger('application-edit-modal-loaded')
    ).fail(
      (error) ->
        console.log error
    )

  $("a[data-reveal-id^='deleteModal-']").click (event) ->
    event.preventDefault()
    application_id = $(this).attr('data-reveal-id').split('-')[1]
    $.get("/applications/#{application_id}/delete_modal").done(
      (success) ->
        $("#deleteApplicationModalContainer").empty()
        $("#deleteApplicationModalContainer").append(success)
        $("#deleteApplicationModalContainer > .modal").openModal()
        $("#deleteApplicationModalContainer").trigger('application-delete-modal-loaded')
    ).fail(
      (error) ->
        console.log error
    )

  $("#application_contract_date").change (event) ->
    if !!$(this).val() && !!$("#application_launch_date").val()
      contract_date = new Date($(this).val())
      launch_date = new Date($("#application_launch_date").val())
      timeDiff = launch_date.getTime() - contract_date.getTime()
      if timeDiff >= 0
        diffDays = Math.ceil(Math.abs(timeDiff) / (1000 * 3600 * 24))
        $("#application_days_to_launch").val(diffDays.toString())

  $('.user-status ul').on 'click', '.init', ->
    $(this).closest('.user-status ul').children('li:not(.init)').toggle()
    return
  allOptions = $('.user-status ul').children('li:not(.init)')
  $('.user-status ul').on 'click', 'li:not(.init)', ->
    allOptions.removeClass 'selected'
    $(this).addClass 'selected'
    $('.user-status ul').children('.init').html $(this).html()
    allOptions.toggle()
    return

  $("#application_launch_date").change (event) ->
    if !!$(this).val() && !!$("#application_contract_date").val()
      launch_date = new Date($(this).val())
      contract_date = new Date($("#application_contract_date").val())
      timeDiff = launch_date.getTime() - contract_date.getTime()
      if timeDiff >= 0
        diffDays = Math.ceil(Math.abs(timeDiff) / (1000 * 3600 * 24))
        $("#application_days_to_launch").val(diffDays.toString())

  $("#deleteApplicationModalContainer").on 'application-delete-modal-loaded', (parent_event) ->
    $(".delete_application").submit (event) ->
      unless $("#delete_confirm").val() == "DELETE"
        alert("Please type DELETE to confirm deletion.")
        return false
      else
        return true

  $("#editApplicationModalContainer").on 'application-edit-modal-loaded', (parent_event)->

    ORGANIZATION_FILE_LIMITS = $('#organization_file_limits').val() && JSON.parse($('#organization_file_limits').val())

    file_preview = ""
    cropbox = ""
    fileObject = {}

    $('.stylesheet-field').minicolors()

    $('select.chosen-select').chosen({
      allow_single_deselect: true,
      no_results_text: 'No results matched',
      disable_search_threshold: 2,
      width: '200px'
    })

    $(".speakap-enabled").click (e) ->
      if $("input[name='application[speakap_enabled]']").prop('checked')
        $("input[name='application[speakap_enabled]']").prop('checked', false)
      else
        $("input[name='application[speakap_enabled]']").prop('checked', true)

    $(".application-saml-enabled").click (e) ->
      if $("input[name='application[saml_enabled]']").prop('checked')
        $("input[name='application[saml_enabled]']").prop('checked', false)
      else
        $("input[name='application[saml_enabled]']").prop('checked', true)

    $(".crop-modal-close").click (e) ->
      $("##{$(this).attr('data-modal')}").closeModal();
      $("body").children("#lean-overlay").remove()
      $div = $("<div ></div>").attr({id: 'lean-overlay', style: 'display: block; opacity: 0.5;'})
      $("body").append($div)

    $(".crop-image-back").click ->
      $(".darkroom-container").children(".darkroom-container").remove()

    $(".edit-application-logo-file").change (event) ->
      file_preview = $(event.target).siblings(".upload-preview-application-logo").find("img")
      $(event.target).siblings(".edit-application-logo-modal").css("display", "inline-block")

      input = $(event.currentTarget)
      file = input[0].files[0]
      return unless !!file
      fileObject.filetype_logo = file.type;
      fileObject.filename_logo = file.name;

      return if fileSizeNotInLimit(file,event,".edit-application-logo-modal",ORGANIZATION_FILE_LIMITS["logo"])

      reader = new FileReader()
      reader.onload = (e) ->
        image_base64 = e.target.result
        file_preview.attr "src", image_base64

        return
      reader.readAsDataURL file
      return

    $('.save-cropped-image-btn').click ->
      if croppie
        src = croppie.get(0).src
        format = croppie.get(0).src.split(';')[0].split('/')[1]
        if !format
          format = 'jpeg'
        croppie.croppie('result',
          type: 'canvas'
          size: 'original'
          format: format
          quality: '0.99'
        ).then (response) ->
          $('.upload-preview img').attr('src', response)

    $('#vpp_file_group_id').change (event) ->
      data = JSON.parse($('#vpp_per_group').val())
      group_id = $(event.target).val()
      if !!group_id
        if !!(data["group_" + group_id])
          text = data["group_" + group_id]["used_links"] + " / " + data["group_" + group_id]["total_links"]
        else
          text = ""
      else
        if !!data["total_links"]
          text = data["used_links"] + " / " + data["total_links"]
        else
          text = ""
      $('#show-vpp-group-links-consumed').html(text)

    $('form[id^="edit_application_"]').submit (e) ->
      e.preventDefault()
      disablePageSubmit()
      twofa_per_role = ''

      if $(e.target).children(".application-vuforia").children("#application_vuforia").val() == 'true'
        vuforia = 1
      else
        vuforia = 0

      if $(e.target).children(".application-api-role").children("#application_api_role").val() == 'Enable'
        api_role = 1
      else
        api_role = 0

      if $(e.target).children(".strict-login").children('#application_strict_login').val() == 'Enable'
        strict_login = 1
      else
        strict_login = 0

      if $(e.target).children(".application-ip").children('#application_ip_restrict').val() == 'Enable'
        ip_restrict = 1
      else
        ip_restrict = 0

      if $(e.target).children(".application-appical-emails").children('#application_appical_emails').val() == 'Enable'
        appical_emails = 1
      else
        appical_emails = 0

      if $(e.target).children(".application-following-email").children('#application_following_email').val() == 'Enable'
        following_email = 1
      else
        following_email = 0

      if $(e.target).children(".application-show-people-from-same-group").find('#application_hr_user_filter').val() == 'Enable'
        hr_user_filter = 1
      else
        hr_user_filter = 0

      enforce_last_day = $(e.target).children(".application-last-day").children('#application_enforce_last_day').is(':checked')

      if $(e.target).children(".application-authentication-method").children('#application_two_factor_authentication').val() == 'Enable'
        twofa_per_role = ''
        roles = []
        $('input[id^="application_2fa_role_"]').each (i, role) ->
          if role.checked
            roles.push(role.value)
        twofa_per_role = roles.join(',')

      file = $('#application_vpp_file')[0].files[0]
      vpp_group_id = $(e.target).find("#vpp_file_group_id").val()
      if !!!vpp_group_id
        vpp_group_id = "0"
      imported_data = {}
      imported_data[vpp_group_id] = [];
      submit_form = true
      form_url = "#{$(this).attr('action')}.json"
      if (file)
        submit_form = false
        reader = new FileReader()
        file_name_parts = file.name.split(".")
        reader.readAsArrayBuffer(file)
        reader.onload = (ee) ->
          if (file_name_parts[file_name_parts.length - 1] == "xlsx")
            binary = String.fromCharCode.apply(null, new Uint8Array(ee.target.result));
            temp1 = XLSX.read(btoa(binary), {type: 'base64'});
            temp2 = to_csv(temp1,'xlsx').split('\n');
            i = 0
            while i < temp2.length
              tmp1 = temp2[i].split(',');
              if(tmp1.length > 1)
                imported_data[vpp_group_id].push(tmp1);
              i++
          else if (file_name_parts[file_name_parts.length - 1] == "xls")
            binary = "";
            bytes = new Uint8Array(ee.target.result);
            length = bytes.byteLength;
            i = 0
            while i < length
              binary += String.fromCharCode(bytes[i])
              i++
            temp1 = XLS.parse_xlscfb(XLS.CFB.read(binary, {type: 'binary'}));
            temp2 = to_csv(temp1,'xlsx').split('\n');

            i = 0
            while i < temp2.length
              tmp1 = temp2[i].split(',');
              if(tmp1.length > 1)
                imported_data[vpp_group_id].push(tmp1);
              i++

          $.ajax(
            type: 'POST',
            url: form_url
            enctype: 'multipart/form-data',
            data:
              'application[notifications_language_id]': $(e.target).children(".notifications-language").children("select").val()
              'application[name]': $(e.target).children(".application-name").children('#application_name').val()
              'application[domain]': $(e.target).children(".application-domain").children('#application_domain').val()
              'application[segment_id]': $(e.target).children(".application-segment").children("select").val(),
              'application[planhat_id]': $(e.target).children(".planhat-id").children('input').val()
              'application[speakap_enabled]': $(e.target).children(".speakap-enabled").children('input').is(':checked')
              'application[speakap_domain]': $(e.target).children(".speakap-domain").children('input').val()
              'application[hroffice_app_id]': $(e.target).children(".hroffice-app-id").children('input').val()
              'application[hroffice_app_secret]': $(e.target).children(".hroffice-app-secret").children('input').val()
              'application[chat_enabled]': $(e.target).children(".chat-enabled").children('input').is(':checked')
              'application[show_appical_accounts]': $(e.target).children(".show-appical-accounts").children('input').is(':checked')
              'application[strict_password_policy]': $(e.target).children(".strict-password-policy").children('input').is(':checked')
              'application[user_privacy][enabled]': $(e.target).children(".user-privacy-enabled").children('input').is(':checked')
              'application[user_privacy][analytics]': $(e.target).children(".user-privacy-analytics").children('input').is(':checked')
              'application[user_privacy][manager_app]': $(e.target).children(".user-privacy-manager-app").children('input').is(':checked')
              'application[user_privacy][reporting]': $(e.target).children(".user-privacy-reporting").children('input').is(':checked')
              'application[follower_settings][inactivity]': $(e.target).children(".follower-settings-inactivity").children('input').is(':checked')
              'application[follower_settings][course_completed]': $(e.target).children(".follower-settings-course-completed").children('input').is(':checked')
              'application[external_user_manager]': $(e.target).children(".external-user-manager").children('input').is(':checked')
              'application[editors_can_invite_users]': $(e.target).children(".editors-can-invite-users").children('input').is(':checked')
              'application[contact_person][first_name]': $(e.target).children(".contact-person-first-name").children('input').val()
              'application[contact_person][last_name]': $(e.target).children(".contact-person-last-name").children('input').val()
              'application[contact_person][email]': $(e.target).children(".contact-person-email").children('input').val()
              'application[contact_person][phone]': $(e.target).children(".contact-person-phone").children('input').val()
              'application[from_email]': $(e.target).children(".from-email").children('input').val()
              'application[gdpr_request_contact_email]': $(e.target).children(".gdpr-request-contact-email").children('input').val()
              'application[app_name]': $(e.target).children(".app-name").children('input').val()
              'application[app_apple_link]': $(e.target).children(".app-apple-link").children('input').val()
              'application[app_google_link]': $(e.target).children(".app-google-link").children('input').val()
              'application[strict_login]': strict_login
              'application[vuforia]': vuforia
              'application[two_factor_authentication]': $(e.target).children(".application-authentication-method").children('#application_two_factor_authentication').val()
              'application[enable_2fa_for]': twofa_per_role
              'application[api_role]': api_role
              'application[aws_storage]': $(e.target).children(".application-aws-storage").children('#application_aws_storage').val()
              'application[plan_id]': $(e.target).children(".application-plan").children('#application_plan_id').val()
              'application[appical_emails]': appical_emails
              'application[following_email]': following_email
              'application[ip_restrict]': ip_restrict
              'application[ip_address]': $(e.target).children(".application-ip").children('#application_ip_address').val()
              'application[saml_idp_url]': $(e.target).children(".application-saml-idp-url").children('#application_saml_idp_url').val()
              'application[saml_domain]': $(e.target).children(".application-saml-domain").children('#application_saml_domain').val()
              'application[saml_enabled]': saml_enabled
              'application[saml_issuer]': $(e.target).children(".application-saml-issuer").children('#application_saml_issuer').val()
              'application[saml_idp_cert]': $(e.target).children(".application-saml-idp-cert").children('#application_saml_idp_cert').val()
              'application[sso_domain]': $(e.target).children(".application-sso-domain").children('#application_sso_domain').val()
              'application[vpp_data]': imported_data
              'application[last_day]': $(e.target).children(".application-last-day").children('#application_last_day').val()
              'application[custom_last_day]': $(e.target).children(".application-last-day").children('#application_custom_last_day').val()
              'application[enforce_last_day]': enforce_last_day
              'application[super_users]': $(e.target).children(".application-super-users").find('#super_user_ids').val()
              'application[hr_user_filter]': hr_user_filter
              'application[time_zone]': $(e.target).children(".application-time-zone").find('#application_time_zone').val()
              'application[date_format]': $(e.target).children(".application-date-format").find('#application_date_format').val()
              'authenticity_token': $('input[name=authenticity_token]').val()
              '_method': 'patch'
          ).done((data, textStatus, jqXHR) ->
            window.location.href = window.location.href.split("applications")[0] + "applications"
            return
          ).fail((jqXHR, textStatus, errorThrown) ->
            alert (jqXHR.responseText)
            enablePageSubmit('Update')
            return
          )

      saml_enabled = $(e.target).children(".application-saml-enabled").children('#application_saml_enabled').is(':checked')

      if $(e.target).children(".application-signing").children('#application_signing').val() == 'Enable'
        signing = 1
      else
        signing = 0

      if $(e.target).children(".application-signing-user-filter").children('#application_signing_user_filter').val() == 'Enable'
        signing_user_filter = 1
      else
        signing_user_filter = 0

      if $(e.target).children(".application-monthly-admin-update").children('#application_monthly_admin_update').val() == 'Enable'
        monthly_admin_update = 1
      else
        monthly_admin_update = 0

      disabled_monthly_admin_update = []
      $('.disabled-monthly-admin-update').find('input:checkbox:not(:checked)').each ->
        disabled_monthly_admin_update.push(this.value)

      if $(e.target).children(".application-expire-session").children('#application_expire_session').val() == 'Enable'
        expire_session = 1
      else
        expire_session = 0

      if $(e.target).children(".application-show-next-chapter-link").children('#application_show_next_chapter_link').val() == 'Enable'
        show_next_chapter_link = 1
      else
        show_next_chapter_link = 0

      if $(e.target).children(".application-show-next-story-link").children('#application_show_next_story_link').val() == 'Enable'
        show_next_story_link = 1
      else
        show_next_story_link = 0

      if $(e.target).children(".application-manager-toolkit-version").children('#application_manager_toolkit_version').val() == 'Enabled'
        manager_toolkit_version = "advanced_manager_toolkit"
      else
        manager_toolkit_version = "no_manager_toolkit"

      if $(e.target).find(".application-docusign-account-type").children('#application_docusign_account_type').val() == 'Production'
        docusign_account_type = "docusign_production_account"
      else
        docusign_account_type = "docusign_sandbox_account"

      if $(e.target).find(".application-docusign-authentication-type").children('#application_docusign_authentication_type').val() == 'Authorization code'
        docusign_authentication_type = "docusign_authorization_code_authentication"
      else
        docusign_authentication_type = "docusign_password_authentication"

      if $(e.target).find('.application-docusign-authentication-type').children(".application-docusign-user-type").children('#application_docusign_user_type').val() == 'Individual'
        docusign_user_type = "docusign_individual_user"
      else
        docusign_user_type = "docusign_application_user"

      if $(e.target).children(".application-show-course-rating").children('#application_show_course_rating').val() == 'Enable'
        show_course_rating = 1
      else
        show_course_rating = 0

      if $(e.target).find(".application-docusign-embed-signing").children('#application_docusign_embed_signing').val() == 'Enable'
        docusign_embed_signing = 1
      else
        docusign_embed_signing = 0

      if $(e.target).children(".application-bounced-emails-update").children('#application_bounced_emails_update').val() == 'Enable'
        bounced_emails_update = 1
      else
        bounced_emails_update = 0

      if $(e.target).children(".application-screening").children('#application_screening').val() == 'Enable'
        screening = 1
      else
        screening = 0

      if $(e.target).children(".application-allow-edit-email").children('#application_allow_edit_email').val() == 'Enable'
        allow_edit_email = 1
      else
        allow_edit_email = 0

      if $(e.target).children(".application-leaderboard").children('#application_leaderboard').val() == 'Enable'
        leaderboard = 1
      else
        leaderboard = 0
 
      if $(e.target).children(".application-dashboard").children('#application_dashboard').val() == 'Enable'
        dashboard = 1
      else
        dashboard = 0

      if $(e.target).children(".application-dashboard").children('#application_dashboard_user_filter').val() == 'Enable'
        dashboard_user_filter = 1
      else
        dashboard_user_filter = 0

      if $(e.target).children(".application-reporting-restricted").children('#application_reporting_restricted').val() == 'Enable'
        reporting_restricted = 1
      else
        reporting_restricted = 0

      if $(e.target).children(".application-hr-forms").children('#application_hr_forms').val() == 'Enable'
        hr_forms = 1
      else
        hr_forms = 0

      if $(e.target).children(".application-profile-page").children('#application_show_remote_id_on_user_profile').val() == 'Enable'
        show_remote_id_on_user_profile = 1
      else
        show_remote_id_on_user_profile = 0

      if $(e.target).children(".application-enable-workflows").children('#application_enable_workflows').val() == 'Enable'
        enable_workflows = 1
      else
        enable_workflows = 0

      if $(e.target).children(".application-intercom").children('#application_intercom').val() == 'Enable'
        intercom = 1
      else
        intercom = 0

      if $(e.target).children(".application-i9form").children('#application_i9form').val() == 'Enable'
        i9form = 1
      else
        i9form = 0

      if $(e.target).children(".application-i9form-account-type").children('#application_i9form_account_type').val() == 'Live'
        i9form_account_type = "i9form_live_account"
      else
        i9form_account_type = "i9form_dev_account"

      if $(e.target).children(".application-validata-account-type").children('#application_validata_account_type').val() == 'Production'
        validata_account_type = "validata_production_account"
      else
        validata_account_type = "validata_test_account"

      screening_valid_users = []
      $.each $('.validata-multiselectcs label').parents('.validata-multiselectcs').find('label'), (index, value) ->
        if $($(value).get(0)).hasClass('checked')
          screening_valid_users.push $($(value).find('input').get(0)).val()
        return
        
      i9form_valid_users = []
      $.each $('.i9form-multiselectcs label').parents('.i9form-multiselectcs').find('label'), (index, value) ->
        if $($(value).get(0)).hasClass('checked')
          i9form_valid_users.push $($(value).find('input').get(0)).val()
        return

      bounced_email_recipients = []
      $('.bounced-email-recipients').each (i, role) ->
        bounced_email_recipients.push({id: $(role).next().val(), email: $(role).find('.ber-email').val(), frequency: $(role).find('.ber-frequency').val()})

      essay_answer_recipients = []
      $('.essay-answer-recipients').each (i, role) ->
        essay_answer_recipients.push({id: $(role).next().val(), email: $(role).find('.ear-email').val(), frequency: $(role).find('.ear-frequency').val()})

      selected_message_user_option = $(e.target).children(".application-message-user-option").children('#application_message_user_option').val()
      if selected_message_user_option == 'Managers/Followings'
        message_user_option = "message_only_managers"
      else if selected_message_user_option == 'AI Buddy only'
        message_user_option = "message_only_buddy"
      else
        message_user_option = "message_all_users"

      if $(e.target).children(".application-message-user-detail").children('#application_message_user_detail').val() == 'Hide user last name and email'
        message_user_detail = "message_hide_user_last_name_email"
      else
        message_user_detail = "message_show_all_user_detail"

      if $(e.target).children(".application-daily-chat-email-notification").children('#application_daily_chat_email_notification').val() == 'Enable'
        daily_chat_email_notification = 1
      else
        daily_chat_email_notification = 0

      if $(e.target).children(".application-signing-source").children('#application_signing_source').val() == 'AdobeSign'
        signing_source = "adobesign"
      else
        signing_source = "docusign"

      if $(e.target).find(".application-adobesign-user-type").children('#application_adobesign_user_type').val() == 'Individual'
        adobesign_user_type = "adobesign_individual_user"
      else
        adobesign_user_type = "adobesign_application_user"

      if submit_form
        $.ajax(
          type: 'POST',
          url: form_url
          enctype: 'multipart/form-data',
          data:
            'application[notifications_language_id]': $(e.target).children(".notifications-language").children("select").val()
            'application[name]': $(e.target).children(".application-name").children('#application_name').val()
            'application[domain]': $(e.target).children(".application-domain").children('#application_domain').val()
            'application[segment_id]': $(e.target).children(".application-segment").children("select").val(),
            'application[planhat_id]': $(e.target).children(".planhat-id").children('input').val()
            'application[speakap_enabled]': $(e.target).children(".speakap-enabled").children('input').is(':checked')
            'application[speakap_domain]': $(e.target).children(".speakap-domain").children('input').val()
            'application[hroffice_app_id]': $(e.target).children(".hroffice-app-id").children('input').val()
            'application[hroffice_app_secret]': $(e.target).children(".hroffice-app-secret").children('input').val()
            'application[chat_enabled]': $(e.target).children(".chat-enabled").children('input').is(':checked')
            'application[show_appical_accounts]': $(e.target).children(".show-appical-accounts").children('input').is(':checked')
            'application[strict_password_policy]': $(e.target).children(".strict-password-policy").children('input').is(':checked')
            'application[user_privacy][enabled]': $(e.target).children(".user-privacy-enabled").children('input').is(':checked')
            'application[user_privacy][analytics]': $(e.target).children(".user-privacy-analytics").children('input').is(':checked')
            'application[user_privacy][manager_app]': $(e.target).children(".user-privacy-manager-app").children('input').is(':checked')
            'application[user_privacy][reporting]': $(e.target).children(".user-privacy-reporting").children('input').is(':checked')
            'application[follower_settings][inactivity]': $(e.target).children(".follower-settings-inactivity").children('input').is(':checked')
            'application[follower_settings][course_completed]': $(e.target).children(".follower-settings-course-completed").children('input').is(':checked')
            'application[external_user_manager]': $(e.target).children(".external-user-manager").children('input').is(':checked')
            'application[external_editor]': $(e.target).children(".external-editor").children('input').is(':checked')
            'application[editors_can_invite_users]': $(e.target).children(".editors-can-invite-users").children('input').is(':checked')
            'application[external_reporter]': $(e.target).children(".external-reporter").children('input').is(':checked')
            'application[contact_person][first_name]': $(e.target).children(".contact-person-first-name").children('input').val()
            'application[contact_person][last_name]': $(e.target).children(".contact-person-last-name").children('input').val()
            'application[contact_person][email]': $(e.target).children(".contact-person-email").children('input').val()
            'application[contact_person][phone]': $(e.target).children(".contact-person-phone").children('input').val()
            'application[from_email]': $(e.target).children(".from-email").children('input').val()
            'application[gdpr_request_contact_email]': $(e.target).children(".gdpr-request-contact-email").children('input').val()
            'application[app_name]': $(e.target).children(".app-name").children('input').val()
            'application[app_apple_link]': $(e.target).children(".app-apple-link").children('input').val()
            'application[app_google_link]': $(e.target).children(".app-google-link").children('input').val()
            'application[strict_login]': strict_login
            'application[vuforia]': vuforia
            'application[two_factor_authentication]': $(e.target).children(".application-authentication-method").children('#application_two_factor_authentication').val()
            'application[enable_2fa_for]': twofa_per_role
            'application[api_role]': api_role
            'application[aws_storage]': $(e.target).children(".application-aws-storage").children('#application_aws_storage').val()
            'application[plan_id]': $(e.target).children(".application-plan").children('#application_plan_id').val()
            'application[appical_emails]': appical_emails
            'application[following_email]': following_email
            'application[signing]': signing
            'application[signing_user_filter]': signing_user_filter
            'application[docusign_account_id]': $(e.target).find('.application-docusign-authentication-type').children(".application-docusign-account-id").children('#application_docusign_account_id').val()
            'application[docusign_account_type]': docusign_account_type
            'application[docusign_authentication_type]': docusign_authentication_type
            'application[docusign_user_type]': docusign_user_type
            'application[docusign_new_signing_notification]': $(e.target).find(".application-docusign-embed-signing").children(".signing-notification-options").children(".docusign-new-signing-notification").children('input').is(':checked')
            'application[docusign_new_signing_email]': $(e.target).find(".application-docusign-embed-signing").children(".signing-notification-options").children(".docusign-new-signing-email").children('input').is(':checked')
            'application[ip_restrict]': ip_restrict
            'application[ip_address]': $(e.target).children(".application-ip").children('#application_ip_address').val()
            'application[saml_idp_url]': $(e.target).children(".application-saml-idp-url").children('#application_saml_idp_url').val()
            'application[saml_domain]': $(e.target).children(".application-saml-domain").children('#application_saml_domain').val()
            'application[saml_enabled]': saml_enabled
            'application[saml_issuer]': $(e.target).children(".application-saml-issuer").children('#application_saml_issuer').val()
            'application[saml_idp_cert]': $(e.target).children(".application-saml-idp-cert").children('#application_saml_idp_cert').val()
            'application[sso_domain]': $(e.target).children(".application-sso-domain").children('#application_sso_domain').val()
            'application[last_day]': $(e.target).children(".application-last-day").children('#application_last_day').val()
            'application[custom_last_day]': $(e.target).children(".application-last-day").children('#application_custom_last_day').val()
            'application[enforce_last_day]': enforce_last_day
            'application[super_users]': $(e.target).children(".application-super-users").find('#super_user_ids').val()
            'application[hr_user_filter]': hr_user_filter
            'application[monthly_admin_update]': monthly_admin_update
            'application[disabled_monthly_admin_update]': disabled_monthly_admin_update
            'application[anonymize_day]': $(e.target).children(".application-anonymize-day").children('#application_anonymize_day').val()
            'application[expire_session]': expire_session
            'application[show_player_tutorial]': $(e.target).children(".application-show-player-tutorial").children('input').is(':checked')
            'application[show_manager_player_tutorial]': $(e.target).children(".application-show-manager-player-tutorial").children('input').is(':checked')
            'application[show_message_player_tutorial]': $(e.target).children(".application-show-message-player-tutorial").children('input').is(':checked')
            'application[show_next_chapter_link]': show_next_chapter_link
            'application[show_next_story_link]': show_next_story_link
            'application[manager_toolkit_version]': manager_toolkit_version
            'application[show_course_rating]': show_course_rating
            'application[docusign_embed_signing]': docusign_embed_signing
            'application[time_zone]': $(e.target).children(".application-time-zone").find('#application_time_zone').val()
            'application[date_format]': $(e.target).children(".application-date-format").find('#application_date_format').val()
            'application[bounced_emails_update]': bounced_emails_update
            'application[screening]': screening
            'application[allow_edit_email]': allow_edit_email
            'application[leaderboard]': leaderboard
            'application[dashboard]': dashboard
            'application[dashboard_user_filter]': dashboard_user_filter
            'application[hr_forms]': hr_forms
            'application[show_remote_id_on_user_profile]': show_remote_id_on_user_profile
            'application[enable_workflows]': enable_workflows
            'application[intercom]': intercom
            'application[i9form]': i9form
            'application[i9form_client_id]': $(e.target).children(".application-i9form-client-id").children('#application_i9form_client_id').val()
            'application[i9form_hash_key]': $(e.target).children(".application-i9form-hash-key").children('#application_i9form_hash_key').val()
            'application[i9form_account_type]': i9form_account_type
            'application[validata_account_type]': validata_account_type
            'application[screening_valid_users]': screening_valid_users
            'application[i9form_valid_users]': i9form_valid_users
            'application[reporting_restricted]': reporting_restricted
            'application[bounced_email_recipients]': bounced_email_recipients
            'application[essay_answer_recipients]': essay_answer_recipients
            'application[message_user_option]': message_user_option
            'application[message_user_detail]': message_user_detail
            'application[daily_chat_email_notification]': daily_chat_email_notification
            'application[adobesign_user_type]': adobesign_user_type
            'application[signing_source]': signing_source
            'application[use_custom_smtp_relay]': $(e.target).children("#smtp-configuration").children(".application-use-custom-smtp-relay").children('#application_use_custom_smtp_relay').is(':checked')
            'application[smtp_address]': $(e.target).children("#smtp-configuration").children(".application-smtp-address").children('#application_smtp_address').val()
            'application[smtp_port]': $(e.target).children("#smtp-configuration").children(".application-smtp-port").children('#application_smtp_port').val()
            'application[smtp_domain]': $(e.target).children("#smtp-configuration").children(".application-smtp-domain").children('#application_smtp_domain').val()
            'application[smtp_authentication]': $(e.target).children("#smtp-configuration").children(".application-smtp-authentication").children('#application_smtp_authentication').val()
            'application[smtp_username]': $(e.target).children("#smtp-configuration").children(".application-smtp-username").children('#application_smtp_username').val()
            'application[smtp_password]': $(e.target).children("#smtp-configuration").children(".application-smtp-password").children('#application_smtp_password').val()
            'application[smtp_openssl_verify_mode]': $(e.target).children("#smtp-configuration").children(".application-smtp-openssl-verify-mode").children('#application_smtp_openssl_verify_mode').val()
            'application[smtp_enable_starttls_auto]': $(e.target).children("#smtp-configuration").children(".application-smtp-enable-starttls-auto").children('#application_smtp_enable_starttls_auto').is(':checked')
            'authenticity_token': $('input[name=authenticity_token]').val()
            '_method': 'patch'
        ).done((data, textStatus, jqXHR) ->
          window.location.href = window.location.href.split("applications")[0] + "applications"
          return
        ).fail((jqXHR, textStatus, errorThrown) ->
          alert (jqXHR.responseText)
          enablePageSubmit('Update')
          return
        )
      true

    $('.back-application-image').click (event) ->
      $('body').prop('scrollTop', 0)
      close = '#editCropApplicationImageModal-' + $((event.target)).attr("id")
      open = '#editModal-' + $((event.target)).attr("id")
      $(close).closeModal()
      $(open).openModal();
      return

    $('.back-application-logo').click (event) ->
      $('body').prop('scrollTop', 0)
      close = '#editCropApplicationLogoModal-' + $((event.target)).attr("id")
      open = '#editModal-' + $((event.target)).attr("id")
      $(close).closeModal()
      $(open).openModal()
      return

    $('.back-application-background').click (event) ->
      $('body').prop('scrollTop', 0)
      close = '#editCropApplicationBackgroundModal-' + $((event.target)).attr("id")
      open = '#editModal-' + $((event.target)).attr("id")
      $(close).closeModal();
      $(open).openModal();
      return

    $('.back-application-login-image').click (event) ->
      $('body').prop('scrollTop', 0)
      close = '#editCropApplicationLoginImageModal-' + $((event.target)).attr("id")
      open = '#editModal-' + $((event.target)).attr("id")
      $(close).closeModal()
      $(open).openModal()
      return

    $('.back-application-wp-tile-image').click (event) ->
      $('body').prop('scrollTop', 0)
      close = '#editCropApplicationWpTileImageModal-' + $((event.target)).attr("id")
      open = '#editModal-' + $((event.target)).attr("id")
      $(close).closeModal()
      $(open).foundation('reveal', 'open');
      return

    $("#course-styling").click (event) ->
      if $("#course-styling").find('.owl-wrapper-outer').length == 0
        $('#course-styling').children().css("border-color", "#e2e2e2")
      else
        $('#course-styling').find('.blueprint-box').css("border-color", "#e2e2e2")
      if event.target.tagName == 'IMG'
        $(event.target).parent().parent().css("border-color", "#3ca0e8")
        $("#copy-course-styling").val($(event.target).parent().parent().find('h6').html())

      else if event.target.tagName == 'H6'
        $(event.target).parent().css("border-color", "#3ca0e8")
        $("#copy-course-styling").val($(event.target).parent().find('h6').html())

      else if event.target.tagName == 'DIV'
        $(event.target).css("border-color", "#3ca0e8")
        $("#copy-course-styling").val($(event.target).find('h6').html())
      return

    $('#application_two_factor_authentication').change (event) ->
      if $(this).val() == 'Enable'
        $('.authentication_per_role_container').show()
      else
        $('.authentication_per_role_container').hide()

    $('#application_last_day').change (event) ->
      if $(this).val() == 'Custom'
        $('#application_custom_last_day').show()
      else
        $('#application_custom_last_day').hide()

    $('#application_docusign_authentication_type').change (event) ->
      if $(this).val() == 'Authorization code'
        $('.auth').show()
        $('.pass').hide()
      else
        $('.pass').show()
        $('.auth').hide()

    $('#application_docusign_embed_signing').change (event) ->
      if $(this).val() == 'Enable'
        $('.signing-notification-options').show()
      else
        $('.signing-notification-options').hide()

    $('#application_manager_toolkit_version').change (event) ->
      if $(this).val() == 'Enabled'
        $('.manager-forwarding').show()
        $('.manager-add-new-hires').show()
      else
        $('.manager-forwarding').hide()
        $('.manager-add-new-hires').hide()

    $('.group_select').multiSelect null, (el) ->
      $('#callbackResult').show().fadeOut()

    $('.multiselectcs label').click ->
      users = []
      $.each $(this).parents('.multiselectcs').find('label'), (index, value) ->
        if $($(value).get(0)).hasClass('checked')
          users.push $($(value).find('input').get(0)).val()
        return
      $(this).parents('.multiselectcs').find('#super_user_ids').val(users)
      
    $('#application_signing_source').change (event) ->
      if $(this).val() == 'AdobeSign'
        $('#adobesign-configuration').show()
        $('#docusign-configuration').hide()
      else
        $('#docusign-configuration').show()
        $('#adobesign-configuration').hide()      

  to_csv = (workbook, type) ->
    result = []
    workbook.SheetNames.forEach (sheetName) ->
      csv = []
      if type == 'xls'
        csv = XLS.utils.sheet_to_csv(workbook.Sheets[sheetName])
      else if type == 'xlsx'
        csv = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName])
      if csv.length > 0
        result.push csv
      return
    result.join '\n'

  return
